import React, { useState, useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function ProjectModal({ project, onClose }) {
  const [idx, setIdx] = useState(0);
  const images = project.images?.length ? project.images : [project.coverImage].filter(Boolean);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") setIdx(i => (i + 1) % images.length);
      if (e.key === "ArrowLeft") setIdx(i => (i - 1 + images.length) % images.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [images.length, onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white max-w-4xl w-full max-h-[90vh] overflow-y-auto rounded-lg"
        onClick={e => e.stopPropagation()}
      >
        {/* Image viewer */}
        <div className="relative bg-gray-100 aspect-video">
          {images[idx] ? (
            <img
              src={images[idx]}
              alt={project.title}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-gray-400">
              No image
            </div>
          )}
          {images.length > 1 && (
            <>
              <button
                onClick={() => setIdx(i => (i - 1 + images.length) % images.length)}
                className="absolute left-3 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2"
              >
                <ChevronLeft size={20} />
              </button>
              <button
                onClick={() => setIdx(i => (i + 1) % images.length)}
                className="absolute right-3 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2"
              >
                <ChevronRight size={20} />
              </button>
              <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-1.5">
                {images.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setIdx(i)}
                    className={`w-2 h-2 rounded-full transition-colors ${i === idx ? "bg-white" : "bg-white/50"}`}
                  />
                ))}
              </div>
            </>
          )}
          <button
            onClick={onClose}
            className="absolute top-3 right-3 bg-white/80 hover:bg-white rounded-full p-2"
          >
            <X size={18} />
          </button>
        </div>

        {/* Info */}
        <div className="p-6">
          <div className="flex items-start justify-between gap-4">
            <h2 className="text-2xl font-semibold" style={{ fontFamily: "var(--font-heading)" }}>
              {project.title}
            </h2>
            <span className="text-xs tracking-widest uppercase text-gray-500 border border-gray-200 px-3 py-1 flex-shrink-0">
              {project.category}
            </span>
          </div>
          <div className="text-sm text-gray-500 mt-1">{project.year}</div>
          {project.description && (
            <p className="mt-4 text-sm text-gray-700 leading-relaxed">{project.description}</p>
          )}
        </div>
      </div>
    </div>
  );
}
